import React from "react";
import SidebarComponent from "./SidebarComponent";
import HeaderComponent from "./HeaderComponent";
const AuthorizedLayoutComponent = ({ children }) => {
  return (
    <>
      <div className="wrapper">
        <HeaderComponent />
        <SidebarComponent />
        <div className="content-wrapper">{children}</div>
      </div>
    </>
  );
};

export default AuthorizedLayoutComponent;
